import { ActionStatus } from '../../types'

export function computeSendMessagePermission(): ActionStatus {
  return 'enabled'
}
